<div *ngIf="loginDisplay">
  <router-outlet></router-outlet>
</div>

<div *ngIf="!loginDisplay" class="loading-container">
  <div class="loading-content">
    <img src="../assets/images/viresco-logo.png" alt="Viresco" class="logo" />
    <h2>Carregando...</h2>
    <p>Redirecionando para login...</p>
    <div class="spinner"></div>
  </div>
</div>

